import AutoComplete, { AutoCompleteProps } from "./AutoComplete";
import Checkbox, { CheckboxProps } from "./Checkbox";
import Counter, { CounterInputProps } from "./Counter";
import CreditCard, { CreditCardInputProps } from "./CreditCard";
import DateTime, { DateTimePickerProps } from "./DateTime";
import DateRangePicker, { DateRangePickerProps } from "./DateRangePicker";
import MaskedTextInput, { MaskedTextInputProps } from "./MaskedInput";
import Phone, { PhoneProps } from "./Phone";
import Radio, { RadioProps } from "./Radio";
import Select, { SelectProps } from "./Select";
import Slider, { SliderProps } from "./Slider";
import StickyTextInput, { StickyTextInputProps } from "./StickyTextInput";
import Text, { TextInputProps } from "./Text";
import TextArea, { TextAreaProps } from "./TextArea";
import TextArray, { TextArrayProps } from "./TextArray";
import Uploader, { IUploaderProps } from "./Uploader";
import RemoteValidateInput, { RemoteValidateInputProps } from "./RemoteValidate";
import RemoteFetchInput, { RemoteFetchProps } from "./RemoteFetch";
import NameInput, { NameInputProps } from "./NameInput";

export interface InputComponents {
	Checkbox: React.FC<CheckboxProps>;
	Counter: React.FC<CounterInputProps>;
	CreditCard: React.FC<CreditCardInputProps>;
	DateTime: React.FC<DateTimePickerProps>;
	DateRangePicker: React.FC<DateRangePickerProps>;
	MaskedTextInput: React.FC<MaskedTextInputProps>;
	Phone: React.FC<PhoneProps>;
	NameInput: React.FC<NameInputProps>;
	Radio: React.FC<RadioProps>;
	Select: React.FC<SelectProps>;
	Slider: React.FC<SliderProps>;
	StickyTextInput: React.FC<StickyTextInputProps>;
	AutoComplete: React.FC<AutoCompleteProps>;
	Text: React.FC<TextInputProps>;
	TextArea: React.FC<TextAreaProps>;
	TextArray: React.FC<TextArrayProps>;
	Uploader: React.FC<IUploaderProps>;
	RemoteValidateInput: React.FC<RemoteValidateInputProps>;
	RemoteFetchInput: React.FC<RemoteFetchProps>;
}

const Input: InputComponents = {
	AutoComplete,
	Checkbox,
	Counter,
	CreditCard,
	DateTime,
	DateRangePicker,
	Radio,
	Select,
	Slider,
	StickyTextInput,
	MaskedTextInput,
	NameInput,
	Phone,
	Text,
	TextArea,
	TextArray,
	Uploader,
	RemoteValidateInput,
	RemoteFetchInput,
};

export default Input;
